import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { OemService } from '../../../../app/core/routing/services/oem/oem.service';

@Component({
  selector: 'iposcen-new-model-sku',
  templateUrl: './new-model-sku.component.html',
  styleUrls: ['./new-model-sku.component.scss']
})
export class NewModelSkuComponent implements OnInit {
  sideNav: string;
  inActive: string;
  skuIdToEdit: string;
  tabEnable;
  constructor(private oemservice: OemService, private activatedRoute: ActivatedRoute, private router: Router) { } 

  ngOnInit(): void {
    this.sideNav = 'model_info';
    this.activatedRoute.params.subscribe(params => {
      this.skuIdToEdit = params[GlobalConstants.AUTO_ID];
      this.oemservice.setAutoId(this.skuIdToEdit);
    });
    this.inActive = '';
  }

  setSideNav(value: string) {
    if(this.skuIdToEdit){
    this.skuIdToEdit = this.oemservice.getAutoId();
    this.sideNav = value;
    window.scroll(0,0);
    }else{
      this.sideNav = value;
    window.scroll(0,0);
    }
    
  }

  redirectToLogin() {
    sessionStorage.clear();
    location.assign(RouterConstants.SLASH);
  }

  redirectToHome(){
    this.router.navigate([RouterConstants. MODEL_SKU_INFO_LINK]);
  }



}
